import { isVerticalBottomLayout } from '@/utils/pay/paywall-slots';

import type { TPaywallSlotProduct } from '@/apis/commerce';

/**
 * paywall_style 埋点字段：付费墙样式枚举与解析。
 * 只按可见 bottom 与是否有可见 top 映射，不再读 split 开关或是否有轮播：
 * - vertical_one_column   无 top 且 bottom 1-3 档竖排单列
 * - coins_only_two_column 其余 4 档（含 0）
 * - original_three_column 可见 bottom > 4
 * split_carousel_card 仅保留类型兼容，本期不再产出。
 */
export type TPaywallStyle =
    | 'original_three_column'
    | 'coins_only_two_column'
    | 'split_carousel_card'
    | 'vertical_one_column';

/**
 * 根据过滤无匹配卡后的可见 slots.bottom 解析付费墙样式。
 * @param visibleBottom 过滤后可见 bottom（竖排时含整本）
 * @param hasVisibleTop 过滤后可见 top（含插入的活动）是否非空；竖排要求 top 为空
 */
export function resolvePaywallStyle(visibleBottom: TPaywallSlotProduct[], hasVisibleTop: boolean): TPaywallStyle {
    if (isVerticalBottomLayout(visibleBottom) && !hasVisibleTop) {
        return 'vertical_one_column';
    }
    if (visibleBottom.length > 4) {
        return 'original_three_column';
    }
    return 'coins_only_two_column';
}
